<script lang="ts" setup>
import { AppLogo } from '@shared/ui/logo'
import { BtnBecomeTutor } from '@features/apply-for-position'

defineOptions({
  name: 'AppHeader',
})

</script>

<template>
  <div class="app-header">
    <div class="app-header__container">
      <a
        class="app-header__logo"
        href="https://brighterly.com"
        aria-label="Brighterly home"
      >
        <AppLogo />
      </a>
      <BtnBecomeTutor
        size="small"
        from="header"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./AppHeader.scss" />